import { useTheme } from "PFApp/theme_context_provider/theme_context_provider_context";
import { Inline, Stack } from "PFComponents/containers";
import { ExperienceCommonProps } from "PFComponents/experience_level/experience_level.types";
import { IconSizeTable } from "PFComponents/icon/icon.utils";
import { Typography } from "PFComponents/typography";
import { Experience } from "PFTypes";
import { useTranslation } from "react-i18next";

import { RatingDots } from "../../rating_dots";

type RequiredExperienceTooltipContentProps = {
  requiredExperience: Experience;
} & ExperienceCommonProps;

export const RequiredExperienceTooltipContent = ({
  requiredExperience,
  experienceLevels,
  experienceLabelMap
}: RequiredExperienceTooltipContentProps) => {
  const { t } = useTranslation("core", { keyPrefix: "skillRatings" });

  const { themeVars } = useTheme();

  return (
    <Stack alignItems="center">
      <Typography tag="p" variant="labelRegular">
        {t("required")}
      </Typography>
      <Inline gap="spacingSm" alignItems="center">
        <RatingDots
          shape="rect"
          experience={requiredExperience}
          color={themeVars["paletteWhite0"]}
          colorSecondary={themeVars["paletteBlue2"]}
          size={IconSizeTable.xxs}
          experienceLevels={experienceLevels}
        />
        <Typography variant="labelBold">{experienceLabelMap[requiredExperience]}</Typography>
      </Inline>
    </Stack>
  );
};
